import { render, staticRenderFns } from "./xdf.vue?vue&type=template&id=2751a8ba&scoped=true&"
import script from "./xdf.vue?vue&type=script&lang=js&"
export * from "./xdf.vue?vue&type=script&lang=js&"
import style0 from "./xdf.vue?vue&type=style&index=0&id=2751a8ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2751a8ba",
  null
  
)

export default component.exports